import { Zap } from 'lucide-react';

interface Props {
  size?: 'sm' | 'md';
}

export function BrandLogo({ size = 'md' }: Props) {
  const box = size === 'sm' ? 'w-6 h-6' : 'w-7 h-7';
  const icon = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
  const text = size === 'sm' ? 'text-[11px]' : 'text-[13px]';

  return (
    <div className="flex items-center gap-2.5">
      <div
        className={`${box} rounded-md flex items-center justify-center shrink-0`}
        style={{
          background: 'oklch(0.65 0.22 285 / 0.15)',
          border: '1px solid oklch(0.65 0.22 285 / 0.35)',
        }}
      >
        <Zap className={icon} style={{ color: 'oklch(0.65 0.22 285)' }} />
      </div>
      <span className={`font-syne font-bold ${text} tracking-widest uppercase`}>
        Helpdesk
      </span>
    </div>
  );
}
